var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1912_3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14L12 10M12 10L8 14M12 10V19",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3895 16.3915C21.3648 15.8597 22.1353 15.0183 22.5793 14.0001C23.0234 12.9818 23.1157 11.8447 22.8417 10.7681C22.5677 9.6916 21.943 8.73696 21.0661 8.0549C20.1893 7.37283 19.1103 7.00218 17.9995 7.00145H16.7395C16.4368 5.83069 15.8726 4.74378 15.0894 3.82244C14.3062 2.9011 13.3243 2.1693 12.2176 1.68206C11.1108 1.19481 9.90802 0.964808 8.69959 1.00933C7.49116 1.05385 6.30854 1.37175 5.24065 1.93911C4.17276 2.50648 3.24738 3.30855 2.53409 4.28503C1.8208 5.26151 1.33816 6.38699 1.12245 7.57684C0.906742 8.7667 0.963577 9.98998 1.28869 11.1547C1.61379 12.3194 2.19871 13.3953 2.99947 14.3015",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14L12 10L8 14",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1912_3584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "#545454"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.f7de9fa8f3eed77cdb7781d920b321c9.svg";
export { ForwardRef as ReactComponent };